import * as React from "react";
import { graphql } from "react-apollo";
import gql from "graphql-tag";

import { fragments } from "app/components/AppComponents/Fraud";
import BOGraphQLLoader from "app/components/BOComponents/BOGraphQLLoader";
import DeviceList from "./DeviceList";

type Props = {
  external_reference: string;
  onDeviceCountChanged: (deviceCount: number) => void;
};

export default graphql<any, Props>(
  gql`
    ${fragments.fraudCommentsParts}

    query devices($external_reference: ID) {
      user(external_reference: $external_reference) {
        fraud_status
        devices {
          external_reference
          created_at
          first_name
          surname
          phone_number
          device_only_fraud_status
          model
          platform
          snapmin_url
          token

          ...FraudCommentsParts

          payments(limit: 1) {
            created_at
            reference
            snapmin_url
          }
        }
      }
    }
  `,
  {
    options: props => ({
      fetchPolicy: "network-only",
      variables: {
        external_reference: props.external_reference
      }
    })
  }
)(props => (
  <BOGraphQLLoader data={props.data!}>
    <DeviceList
      fraudStatus={props.data.user && props.data.user.fraud_status}
      devices={props.data.user && props.data.user.devices}
      onDeviceCountChanged={props.onDeviceCountChanged}
      refetchData={props.data.refetch}
    />
  </BOGraphQLLoader>
));
